module.exports = __webpack_public_path__ + "img/mihit.69684c84.jpg";